module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"{number} Articles":"{number} Articles"},"de":{"Purchase could not be saved.":"Bestellung konnte nicht gespeichert werden.","Purchase saved successfully!":"Bestellung erfolgreich gespeichert!","Customer":"Kunde","Articles":"Artikel","{number} Articles":"{number} Artikel","Shipping":"Versand","Payment":"Zahlung","Previous":"Zurück","Next":"Weiter"}}')
  delete Component.options._Ctor
}
